import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '100%',
    margin: '0 auto',
    padding: theme.spacing(3, 3, 6, 3),
  },
  carregando: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(6),
  },

  tooltip: {
    backgroundColor: '#fff',
    color: '#333',
    border: '1px solid #ddd',
    boxShadow: '0px 2px 8px rgba(0,0,0,0.15)',
    fontSize: 12,
  },
  arrow: {
    color: '#fff',
  },
  card: {
    borderRadius: 16,
    padding: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
  },
  left: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  iconWrapper: {
    width: 48,
    height: 48,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    fontWeight: 500,
    fontSize: 16,
  },
  subtitle: {
    fontSize: 12,
    color: '#666',
  },
  value: {
    fontSize: 32,
    fontWeight: 600,
  },
  progressBar: {
    marginTop: 8,
    height: 6,
    borderRadius: 8,
    width: 40,
  },
  cardEmCustodia: { backgroundColor: '#fdebd0', color: '#3f2a27' },
  cardEncaminhado: { backgroundColor: '#fdecea', color: '#e74c3c' },
  cardEntrega: { backgroundColor: '#d6e2d5', color: '#2f8623' },
  cardSolicitacao: { backgroundColor: '#f4f8b6', color: '#9c9a09' },
  avisoPaper: {
    marginTop: 20,
    padding: 15,
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(211, 47, 47, 0.15)' : '#fdecea',
    color: theme.palette.type === 'dark' ? '#fdecea' : theme.palette.text.primary,
    display: 'flex',
    alignItems: 'center',
    border: `1px solid ${theme.palette.type === 'dark' ? 'rgba(211, 47, 47, 0.3)' : 'transparent'}`,
  },
  avisoIcon: {
    color: '#d32f2f',
    marginRight: 10,
  },
  tabsContainer: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(2),
    width: 'max-content',
    position: 'relative',
    zIndex: 1,
  },
  tab: {
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.95rem',
    minWidth: 140,
    letterSpacing: '0.2px',
  },
  detailPanelContainer: {
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.background.default : '#fcfcfc',
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  detailPanelItem: {
    padding: theme.spacing(1),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    backgroundColor: theme.palette.background.paper,
    marginBottom: theme.spacing(1),
  },
  panelWithSearch: {
    marginTop: -74,
    '& .MuiToolbar-root': {
      marginBottom: 10,
    }
  },
  ['@media (max-width: 1450px)']: {
    panelWithSearch: {
      marginTop: -28,
      '& .MuiToolbar-root': {
        marginBottom: 0,
      }
    }
  },
  [theme.breakpoints.down('sm')]: {
    panelWithSearch: {
      marginTop: -16,
      '& .MuiToolbar-root': {
        marginBottom: 0,
      }
    }
  },
}))

export default useStyles
export { useStyles }
